export function match(param: string) {
  return /^page-\d+/.test(param);
}
